import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { SeguridadService } from '../servicios/seguridad.service';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private seguridadService: SeguridadService, private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const rutasAutenticacion = ['/validar-credenciales','/validar-token-inicio-sesion-y-autenticar','/es-usuario-admin']
    const jwt: string = this.seguridadService.getJwt();
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${jwt}`
      }
    });

    return next.handle(request).pipe(
      catchError(e => {

        const status: number = e.status;
        const url: string = e.url;

        let esAutenticacion: boolean = false;

        for (let i = 0; i < rutasAutenticacion.length; i++) {
          if(url.includes(rutasAutenticacion[i])){
            esAutenticacion = true;
            break;
          }   
        }

        if ([401, 403].includes(status) && !esAutenticacion) {
          this.seguridadService.logout();
          this.router.navigate(['/acceso-denegado']);
        }
        return throwError(e);
      })
    );
  }
}
